import {area, mk} from '@mintdata/mint-kit/api/log/mk';
import {PopupManager} from '@mintdata/mint-kit/impl/components/popover/PopupManager';
import {PopupItem} from '@mintdata/mint-kit/impl/components/popover/PopupState';
import {PopupGroup} from '@mintdata/mint-kit/impl/components/popover/PopupTypes';
import {bind} from 'bind-decorator';

export class PopupMouseCloser
{
    constructor(public popupManager:PopupManager)
    {
    }

    startListeningToMouseEvents(aWindow:any = window):PopupMouseCloser
    {
        aWindow.addEventListener('mousedown', this._onMouseClick, true /* capture phase*/);
        return this;
    }

    @bind
    private _onMouseClick(e:any)
    {
        const isPopupSource = this.popupManager.isElementPopupSource(e.target);

        if( isPopupSource )
        {
            const popupItem:PopupItem = this.popupManager.findPopupFromSource(e.target);
            const popupGroup:PopupGroup = popupItem.specProps.group;

            this.popupManager.closePopupsExcept(popupGroup);

            return;
        }

        const itemWithIndex = this.popupManager.findPopupFromElement(e.target);

        mk.debug(area.Popup, `PopupMouseHandler :: mouse clicked, event: `, e);

        if( itemWithIndex )
        {
            mk.debug(area.Popup, `FOUND POPUP: ${itemWithIndex}`, itemWithIndex);
            this.popupManager.onPopupItemClicked(itemWithIndex);
        }
        else
        {
            mk.debug(area.Popup, `NON popup click`);
            this.popupManager.onNonPopupItemClicked();
        }
    }
}
